module.exports = __webpack_public_path__ + "img/cloud_upload.ffdefa4c.svg";